module.exports = __webpack_public_path__ + "static/media/Support_Center.b2c0eaf3.svg";